 

import type { RouteObject } from 'react-router';
import { lazyRoute, lazyRouteWithProps } from '../utils/lazyRoute.tsx';

const ameRoutes: RouteObject[] = [
  {
    path: 'AME/*',
    children: [
      { path: 'HomePage', lazy: lazyRoute(() => import('../../pages/Ame/DashBoard/AmeDahboard.jsx')) },

      { path: 'Forms', lazy: lazyRoute(() => import('../../pages/NTX/FlexValue/AmeForms/Forms.jsx')) },

      { path: 'RequestSetting', lazy: lazyRoute(() => import('../../pages/Ame/RequestSettings/RequestSettings.jsx')) },

      { path: 'RequestSetting/:id/AddAmeRule', lazy: lazyRoute(() => import('../../pages/Ame/AmeRule/AmeRule/AddAmeRule.jsx')) },

      {
        path: 'RequestSetting/:id/AddAmeRule/:ruleId/AddAmeAction',
        lazy: lazyRoute(() => import('../../pages/Ame/AmeRule/AmeActionRule/AddAmeAction.jsx'))
      },

      { path: 'ApprovalGroup', lazy: lazyRoute(() => import('../../pages/Ame/ApprovalGroup/ApprovalGroup.jsx')) },

      {
        path: 'ApprovalGroup/:id/AddApprovalMember',
        lazy: lazyRoute(() => import('../../pages/Ame/ApprovalMember/AddApprovalMember.jsx'))
      },

      { path: 'FollowRequests', lazy: lazyRoute(() => import('../../pages/Ame/AllRequests/AllRequests.tsx')) },

      { path: 'NtxTest', lazy: lazyRoute(() => import('../../pages/Ame/Signature.tsx')) },

      // ___________________ SelfService ___________________
      {
        path: 'SelfService/*',
        children: [
          { path: 'Requests', lazy: lazyRoute(() => import('../../pages/Ame/Requests/AmeRequests/AmeRequests.jsx')) },

          { path: 'Requests/:FormId/AddRequest', lazy: lazyRoute(() => import('../../pages/Ame/Requests/AddRequests.jsx')) },

          {
            path: 'Requests/:TransactionHistoryId/ViewRequests',
            lazy: lazyRoute(() => import('../../pages/Ame/ViewRequests/ViewRequests.jsx'))
          },

          {
            path: 'Requests/:TransactionHistoryId/OnlyViewRequests',
            lazy: lazyRouteWithProps(
              () => import('../../pages/Ame/ViewRequests/ViewRequests.jsx'),
              () => ({ isAction: false })
            )
          },

          { path: 'MyRequests', lazy: lazyRoute(() => import('../../pages/Ame/ViewRequests/MyRequests/MyRequests.jsx')) },

          { path: 'AllRequests', lazy: lazyRoute(() => import('../../pages/Ame/AllRequests/AllRequests.tsx')) }
        ]
      }
    ]
  }
];

export default ameRoutes;
